export const firebaseConfig = { 
    apiKey: "AIzaSyCEftC3DWX-gtlx8bUi-t0OcCHvROS7ey0",
    authDomain: "zuzu-51286.firebaseapp.com",
    databaseURL: "https://zuzu-51286.firebaseio.com",
    projectId: "zuzu-51286",
    storageBucket: "zuzu-51286.appspot.com",
    messagingSenderId: "282181737925"
};


// WEBPACK FOOTER //
// ./src/config.js